import actionConstants from '../constants/';
import { PDF_UPLOAD_INVALID_FILE_ERROR } from '../../lib/constants';

const businessDetailsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  businessWebsiteURL: '',
  privacyPolicyURL: '',
  annualTurnOver: '',
  businessCategory: '',
  businessSubCategory: '',
  merchantId: '',
};

const kycVerificationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  merchantId: '',
  merchantPAN: '',
  kycRefId: '',
  documentType: '',
  error: '',
  requestId: '',
  id: '',
  status: '',
  url: '',
  validUpto: '',
  errorMessage: '',
};

const fetchKycDetailsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  merchantId: '',
  merchantPAN: '',
  kycRefId: '',
  documentType: '',
  error: '',
  requestId: '',
  documentNumber: '',
  documentData: {
    completeAddress: '',
    dateOfBirth: '',
    email: '',
    gender: '',
    generatedAt: '',
    maskedNumber: '',
    name: '',
    phone: '',
    photoUrl: '',
    verified: {
      email: false,
      phone: false,
      signature: false,
    },
    address: null,
  },
};

const stepperDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const saveAndNext = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: ''
};

const autosaveStep = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: ''
};

const sidebarStepClick = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: ''
};

const bankAccountVerificationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: null,
  errorMessage: ''
};

const digiVerificationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: ''
};

const digiDetailsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage:'',
};

const getVideoKycUrlState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage:'',
};

const getVideoKycStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const productListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false, 
  products: [],
  errorMessage: '',
};

const selectedProductListState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  responseCode: '',
  responseMessage: '',
  href: '',
  errorMessage: '',
};

const panValidationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorTitle:'',
  errorMessage:'',
  data: {}
};

const getMccState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorTitle:'',
  errorMessage:'',
  data: {}
};

const fetchGstDetailsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  merchantPAN: '',
  kycRefId: '',
  documentType: '',
  requestId: '',
  documentNumber: '',
  gst: [
    {
      address: [
        {
          buildingNumber: '',
          district: '',
          latitude: '',
          location: '',
          longitude: '',
          pinCode: '',
          stateCode: '',
          street: '',
          businessAddress: '',
        },
      ],
      formattedAddress: [
        {
          addressLine1: '',
          addressLine2: '',
          landmark: '',
          city: '',
          state: '',
          pinCode: '',
          latitude: '',
          longitude: '',
          country: '',
          businessAddress: '',
        },
      ],
      legalName: '',
      tradeName: '',
      registrationDate: '',
      businessName: '',
      gstin: '',
    },
  ],
};

const gstValidationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data:[],
  errorTitle:'',
  errorMessage:'',
};

const panGstDetails = {
  isLoading: false,
  isSuccess: false,
  isFailure: false, 
  errorTitle:'',
  errorMessage:'',
  data: [],
};

const getStateDataState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: [],
  errorMessage: '',
};


const getCitiesDataState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: [],
  errorMessage: '',
};

const getCompleteVKYCJourneyState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const getReviewStepUpdateState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const kycImageState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  imageUrl: null,
};

const sendOtpPdfState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const validateOtpPdfState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: ''
};

const showPdfState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  pdfUrl: null,
  errorMessage: '',
};

const showOpportunityStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const toggleEnvState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const cinNumberValidationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const createReviewRequestState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const deleteReviewRequestState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const publicTokenValidationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorMessage: '',
  data: {},
};

const confirmChildSelectionState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const fetchUploadDocumentsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const uploadDocumentState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const rejectionClarificationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const getEslignUrlState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const sendEmailCompanyDirectorState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const getEsignStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const addAndUpdateBeneficiaryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const resendEmailBeneficiaryState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const getBeneficiaryOwnersState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const downloadReportsState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const panKycAgreementValidationState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  errorTitle:'',
  errorMessage:'',
  data: {}
};

const getAgreementEsignUrlState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

export const getDocumentEsignStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

export const getAgreementEsignStatusState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

export const sendEmailKycAgreementState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const sendVerificationCodeCkycState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const verifyCkycOtpState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};

const downloadCkycDataState = {
  isLoading: false,
  isSuccess: false,
  isFailure: false,
  data: {},
  errorMessage: '',
};


const initialState = {
  productListState: { ...productListState },
  selectedProductListState: { ...selectedProductListState },
  panValidationState: { ...panValidationState },
  fetchGstDetailsState: { ...fetchGstDetailsState },
  gstValidationState: { ...gstValidationState },
  businessDetailsState: { ...businessDetailsState },
  kycVerificationState: { ...kycVerificationState },
  fetchKycDetailsState: { ...fetchKycDetailsState },
  stepperDetails: {...stepperDetails},
  digiVerificationState: {...digiVerificationState},
  digiDetailsState: {...digiDetailsState},
  panGstDetails: {...panGstDetails},
  saveAndNext: {...saveAndNext},
  autosaveStep: {...autosaveStep},
  sidebarStepClick: {...sidebarStepClick},
  getMccState: {...getMccState},
  getVideoKycUrlState:{...getVideoKycUrlState},
  getVideoKycStatusState:{...getVideoKycStatusState},
  getStateDataState:{...getStateDataState},
  getCitiesDataState: {...getCitiesDataState},
  getCompleteVKYCJourneyState:{...getCompleteVKYCJourneyState},
  getReviewStepUpdateState:{...getReviewStepUpdateState},
  kycImageState: {...kycImageState},
  bankAccountVerificationState: {...bankAccountVerificationState},
  sendOtpPdfState: {...sendOtpPdfState},
  validateOtpPdfState:{ ...validateOtpPdfState},
  showPdfState: {...showPdfState},
  showOpportunityStatusState: { ...showOpportunityStatusState },
  toggleEnvState: { ...toggleEnvState },
  publicTokenValidationState: { ...publicTokenValidationState },
  cinNumberValidationState: { ...cinNumberValidationState },
  createReviewRequestState: { ...createReviewRequestState },
  deleteReviewRequestState: { ...deleteReviewRequestState },
  confirmChildSelectionState: { ...confirmChildSelectionState },
  fetchUploadDocumentsState: { ...fetchUploadDocumentsState },
  uploadDocumentState: { ...uploadDocumentState },
  rejectionClarificationState: {...rejectionClarificationState},
  getEslignUrlState: { ...getEslignUrlState },
  sendEmailCompanyDirectorState: { ...sendEmailCompanyDirectorState },

  getEsignStatusState: { ...getEsignStatusState },
  addAndUpdateBeneficiaryState: { ...addAndUpdateBeneficiaryState },
  resendEmailBeneficiaryState: { ...resendEmailBeneficiaryState },
  getBeneficiaryOwnersState: { ...getBeneficiaryOwnersState },
  downloadReportsState: { ...downloadReportsState },
  panKycAgreementValidationState: { ...panKycAgreementValidationState },
  getAgreementEsignUrlState: { ...getAgreementEsignUrlState },
  getDocumentEsignStatusState: { ...getDocumentEsignStatusState },
  getAgreementEsignStatusState: {...getAgreementEsignStatusState},
  sendEmailKycAgreementState: { ...sendEmailKycAgreementState },
  sendVerificationCodeCkycState: { ...sendVerificationCodeCkycState },
  verifyCkycOtpState: { ...verifyCkycOtpState },
  downloadCkycDataState: { ...downloadCkycDataState },
  mapCkycDataState: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    data: {},
    errorMessage: '',
  },
  updatePciDssConsentState: {
    isLoading: false,
    isSuccess: false,
    isFailure: false,
    data: {},
    errorMessage: '',
  },
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default function onboardingReducer(state = initialState, action) {
  switch (action.type) {

    case actionConstants.POST_SEND_VERIFICATION_CODE_CKYC_REQUEST:
    return{
      ...state,
      sendVerificationCodeCkycState: {
        ...state.sendVerificationCodeCkycState,
        isLoading: true,
        isSuccess: false,
        isFailure: false,
        data: {},
        errorMessage: '',
      },
    };
  case actionConstants.POST_SEND_VERIFICATION_CODE_CKYC_SUCCESS:
    return {
      ...state,
      sendVerificationCodeCkycState: {
        ...state.sendVerificationCodeCkycState,
        isLoading: false,
        isSuccess: true,
        isFailure: false,
        data: action?.payload?.body,
        errorMessage: '',
      },
    };
  case actionConstants.POST_SEND_VERIFICATION_CODE_CKYC_FAILURE:
    return {
      ...state,
      sendVerificationCodeCkycState: {
        ...state.sendVerificationCodeCkycState,
        isLoading: false,
        isSuccess: false,
        isFailure: true,
        data: {},
        errorMessage:
          action?.payload?.body?.error_details?.errorMessage ||
          action?.payload?.body?.message ||
          'Failed to send verification code',
      },
    };
    case actionConstants.POST_SEND_VERIFICATION_CODE_CKYC_CLEAR:
      return{
        ...state,
        sendVerificationCodeCkycState: {
          ...state.sendVerificationCodeCkycState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        }
      };
      
      case actionConstants.POST_VERIFY_CKYC_CODE_REQUEST:
    return{
      ...state,
      verifyCkycOtpState: {
        ...state.verifyCkycOtpState,
        isLoading: true,
        isSuccess: false,
        isFailure: false,
        data: {},
        errorMessage: '',
      },
    };
  case actionConstants.POST_VERIFY_CKYC_CODE_SUCCESS:
    return {
      ...state,
      verifyCkycOtpState: {
        ...state.verifyCkycOtpState,
        isLoading: false,
        isSuccess: true,
        isFailure: false,
        data: action?.payload?.body,
        errorMessage: '',
      },
    };
  case actionConstants.POST_VERIFY_CKYC_CODE_FAILURE:
    return {
      ...state,
      verifyCkycOtpState: {
        ...state.verifyCkycOtpState,
        isLoading: false,
        isSuccess: false,
        isFailure: true,
        data: {},
        errorMessage: action?.payload?.body?.message || 'Failed to verify OTP',
      },
    };
    case actionConstants.POST_VERIFY_CKYC_CODE_CLEAR:
      return{
        ...state,
        verifyCkycOtpState: {
          ...state.verifyCkycOtpState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        }
      };

    case actionConstants.POST_DOWNLOAD_CKYC_DATA_REQUEST:
      return {
        ...state,
        downloadCkycDataState: {
          ...state.downloadCkycDataState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.POST_DOWNLOAD_CKYC_DATA_SUCCESS:
      return {
        ...state,
        downloadCkycDataState: {
          ...state.downloadCkycDataState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.POST_DOWNLOAD_CKYC_DATA_FAILURE:
      return {
        ...state,
        downloadCkycDataState: {
          ...state.downloadCkycDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to download CKYC data',
        },
      };

    case actionConstants.POST_DOWNLOAD_CKYC_DATA_CLEAR:
      return {
        ...state,
        downloadCkycDataState: {
          ...state.downloadCkycDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.POST_MAP_CKYC_DATA_REQUEST:
      return {
        ...state,
        mapCkycDataState: {
          ...state.mapCkycDataState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.POST_MAP_CKYC_DATA_SUCCESS:
      return {
        ...state,
        mapCkycDataState: {
          ...state.mapCkycDataState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.POST_MAP_CKYC_DATA_FAILURE:
      return {
        ...state,
        mapCkycDataState: {
          ...state.mapCkycDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to map CKYC data',
        },
      };

    case actionConstants.POST_MAP_CKYC_DATA_CLEAR:
      return {
        ...state,
        mapCkycDataState: {
          ...state.mapCkycDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.SEND_EMAIL_KYC_AGREEMENT_REQUEST:
      return {
        ...state,
        sendEmailKycAgreementState: {
          ...state.sendEmailKycAgreementState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.SEND_EMAIL_KYC_AGREEMENT_SUCCESS:
      return {
        ...state,
        sendEmailKycAgreementState: {
          ...state.sendEmailKycAgreementState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.SEND_EMAIL_KYC_AGREEMENT_FAILURE:
      return {
        ...state,
        sendEmailKycAgreementState: {
          ...state.sendEmailKycAgreementState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to send email for KYC agreement',
        },
      };
    case actionConstants.SEND_EMAIL_KYC_AGREEMENT_CLEAR:
      return {
        ...state,
        sendEmailKycAgreementState: {
          ...state.sendEmailKycAgreementState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.DOWNLOAD_REPORTS_REQUEST:
      return {
        ...state,
        downloadReportsState: {
          ...state.downloadReportsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.DOWNLOAD_REPORTS_SUCCESS:
      return {
        ...state,
        downloadReportsState: {
          ...state.downloadReportsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.DOWNLOAD_REPORTS_FAILURE:
      return {
        ...state,
        downloadReportsState: {
          ...state.downloadReportsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to download report',
        },
      };

    case actionConstants.DOWNLOAD_REPORTS_CLEAR:
      return {
        ...state,
        downloadReportsState: {
          ...state.downloadReportsState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
      
    case actionConstants.GET_AGREEMENT_ESIGN_STATUS_REQUEST:
      return {
        ...state,
        getAgreementEsignStatusState: {
          ...state.getAgreementEsignStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.GET_AGREEMENT_ESIGN_STATUS_SUCCESS:
      return {
        ...state,
        getAgreementEsignStatusState: {
          ...state.getAgreementEsignStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.GET_AGREEMENT_ESIGN_STATUS_FAILURE:
      return {
        ...state,
        getAgreementEsignStatusState: {
          ...state.getAgreementEsignStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to get agreement e-sign status',
        },
      };
    case actionConstants.GET_AGREEMENT_ESIGN_STATUS_CLEAR:
      return {
        ...state,
        getAgreementEsignStatusState: {
          ...state.getAgreementEsignStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };


    case actionConstants.GET_DOCUMENT_ESIGN_STATUS_REQUEST:
      return {
        ...state,
        getDocumentEsignStatusState: {
          ...state.getDocumentEsignStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.GET_DOCUMENT_ESIGN_STATUS_SUCCESS:
      return {
        ...state,
        getDocumentEsignStatusState: {
          ...state.getDocumentEsignStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.GET_DOCUMENT_ESIGN_STATUS_FAILURE:
      return {
        ...state,
        getDocumentEsignStatusState: {
          ...state.getDocumentEsignStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to get document e-sign status',
        },
      };
    case actionConstants.GET_DOCUMENT_ESIGN_STATUS_CLEAR:
      return {
        ...state,
        getDocumentEsignStatusState: {
          ...state.getDocumentEsignStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
      
    
    case actionConstants.GET_AGREEMENT_ESIGN_URL_REQUEST:
      return {
        ...state,
        getAgreementEsignUrlState: {
          ...state.getAgreementEsignUrlState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.GET_AGREEMENT_ESIGN_URL_SUCCESS:
      return {
        ...state,
        getAgreementEsignUrlState: {
          ...state.getAgreementEsignUrlState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.GET_AGREEMENT_ESIGN_URL_FAILURE:
      return {
        ...state,
        getAgreementEsignUrlState: {
          ...state.getAgreementEsignUrlState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to get agreement e-sign URL',
        },
      };
    case actionConstants.GET_AGREEMENT_ESIGN_URL_CLEAR:
      return {
        ...state,
        getAgreementEsignUrlState: {
          ...state.getAgreementEsignUrlState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.PAN_KYC_AGREEMENT_REQUEST:
      return {
        ...state,
        panKycAgreementValidationState: {
          ...state.panKycAgreementValidationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.PAN_KYC_AGREEMENT_SUCCESS:
      return {
        ...state,
        panKycAgreementValidationState: {
          ...state.panKycAgreementValidationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.PAN_KYC_AGREEMENT_FAILURE:
      return {
        ...state,
        panKycAgreementValidationState: {
          ...state.panKycAgreementValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to validate PAN KYC agreement',
        },
      };
    case actionConstants.PAN_KYC_AGREEMENT_CLEAR:
      return {
        ...state,
        panKycAgreementValidationState: {
          ...state.panKycAgreementValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.GET_ESIGN_STATUS_REQUEST:
      return {
        ...state,
        getEsignStatusState: {
          ...state.getEsignStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.GET_ESIGN_STATUS_SUCCESS:
      return {
        ...state,
        getEsignStatusState: {
          ...state.getEsignStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.GET_ESIGN_STATUS_FAILURE:
      return {
        ...state,
        getEsignStatusState: {
          ...state.getEsignStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to get e-sign status',
        },
      };
    case actionConstants.GET_ESIGN_STATUS_CLEAR:
      return {
        ...state,
        getEsignStatusState: {
          ...state.getEsignStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.SEND_EMAIL_COMPANY_DIRECTOR_REQUEST:
      return {
        ...state,
        sendEmailCompanyDirectorState: {
          ...state.sendEmailCompanyDirectorState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.SEND_EMAIL_COMPANY_DIRECTOR_SUCCESS:
      return {
        ...state,
        sendEmailCompanyDirectorState: {
          ...state.sendEmailCompanyDirectorState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.SEND_EMAIL_COMPANY_DIRECTOR_FAILURE:
      return {
        ...state,
        sendEmailCompanyDirectorState: {
          ...state.sendEmailCompanyDirectorState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to send email to company director',
        },
      };
    case actionConstants.SEND_EMAIL_COMPANY_DIRECTOR_CLEAR:
      return {
        ...state,
        sendEmailCompanyDirectorState: {
          ...state.sendEmailCompanyDirectorState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.GENERATE_ESIGN_URL_REQUEST:
      return {
        ...state,
        getEslignUrlState: {
          ...state.getEslignUrlState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.GENERATE_ESIGN_URL_SUCCESS:
      return {
        ...state,
        getEslignUrlState: {
          ...state.getEslignUrlState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.GENERATE_ESIGN_URL_FAILURE:
      return {
        ...state,
        getEslignUrlState: {
          ...state.getEslignUrlState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to generate e-sign URL',
        },
      };

    case actionConstants.GENERATE_ESIGN_URL_CLEAR:
      return {
        ...state,
        getEslignUrlState: {
          ...state.getEslignUrlState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.UPLOAD_DOCUMENT_REQUEST:
      return {
        ...state,
        uploadDocumentState: {
          ...state.uploadDocumentState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.UPLOAD_DOCUMENT_SUCCESS:
      return {
        ...state,
        uploadDocumentState: {
          ...state.uploadDocumentState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.UPLOAD_DOCUMENT_FAILURE: {
      const uploadErrorCode = action?.payload?.body?.code;
      const uploadErrorMsg = action?.payload?.body?.message || '';
      const isWafBlock = uploadErrorCode === 403 || 
        (uploadErrorCode === 0 && uploadErrorMsg.includes('Origin is not allowed by Access-Control-Allow-Origin'));
      const uploadErrorMessage = isWafBlock
        ? PDF_UPLOAD_INVALID_FILE_ERROR
        : uploadErrorMsg || 'Failed to upload document';
      return {
        ...state,
        uploadDocumentState: {
          ...state.uploadDocumentState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: uploadErrorMessage,
        },
      };
    }
    case actionConstants.UPLOAD_DOCUMENT_CLEAR:
      return {
        ...state,
        uploadDocumentState: {
          ...state.uploadDocumentState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.REJECTION_CLARIFICATION_REQUEST:
      return {
        ...state,
        rejectionClarificationState: {
          ...state.rejectionClarificationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.REJECTION_CLARIFICATION_SUCCESS:
      return {
        ...state,
        rejectionClarificationState: {
          ...state.rejectionClarificationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };

    case actionConstants.REJECTION_CLARIFICATION_FAILURE:
      return {
        ...state,
        rejectionClarificationState: {
          ...state.rejectionClarificationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to upload document',
        },
      };
    case actionConstants.REJECTION_CLARIFICATION_CLEAR:
      return {
        ...state,
        rejectionClarificationState: {
          ...state.rejectionClarificationState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.FETCH_UPLOAD_DOCUMENTS_REQUEST:
      return {
        ...state,
        fetchUploadDocumentsState: {
          ...state.fetchUploadDocumentsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.FETCH_UPLOAD_DOCUMENTS_SUCCESS:
      return {
        ...state,
        fetchUploadDocumentsState: {
          ...state.fetchUploadDocumentsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.FETCH_UPLOAD_DOCUMENTS_FAILURE:
      return {
        ...state,
        fetchUploadDocumentsState: {
          ...state.fetchUploadDocumentsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to fetch upload documents',
        },
      };
    case actionConstants.FETCH_UPLOAD_DOCUMENTS_CLEAR:
      return {
        ...state,
        fetchUploadDocumentsState: {
          ...state.fetchUploadDocumentsState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.CONFIRM_CHILD_SELECTION_REQUEST:
      return {
        ...state,
        confirmChildSelectionState: {
          ...state.confirmChildSelectionState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.CONFIRM_CHILD_SELECTION_SUCCESS:
      return {
        ...state,
        confirmChildSelectionState: {
          ...state.confirmChildSelectionState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.CONFIRM_CHILD_SELECTION_FAILURE:
      return {
        ...state,
        confirmChildSelectionState: {
          ...state.confirmChildSelectionState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to confirm child selection',
        },
      };
    case actionConstants.CONFIRM_CHILD_SELECTION_CLEAR:
      return {
        ...state,
        confirmChildSelectionState: {
          ...state.confirmChildSelectionState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.DELETE_REVIEW_REQUEST_REQUEST:
      return {
        ...state,
        deleteReviewRequestState: {
          ...state.deleteReviewRequestState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.DELETE_REVIEW_REQUEST_SUCCESS:
      return {
        ...state,
        deleteReviewRequestState: {
          ...state.deleteReviewRequestState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.DELETE_REVIEW_REQUEST_FAILURE:
      return {
        ...state,
        deleteReviewRequestState: {
          ...state.deleteReviewRequestState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to delete review request',
        },
      };
    case actionConstants.DELETE_REVIEW_REQUEST_CLEAR:
      return {
        ...state,
        deleteReviewRequestState: {
          ...state.deleteReviewRequestState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.CREATE_REVIEW_REQUEST_REQUEST:
      return {
        ...state,
        createReviewRequestState: {
          ...state.createReviewRequestState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.CREATE_REVIEW_REQUEST_SUCCESS:
      return {
        ...state,
        createReviewRequestState: {
          ...state.createReviewRequestState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.CREATE_REVIEW_REQUEST_FAILURE:
      return {
        ...state,
        createReviewRequestState: {
          ...state.createReviewRequestState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to create review request',
        },
      };
    case actionConstants.CREATE_REVIEW_REQUEST_CLEAR:
      return {
        ...state,
        createReviewRequestState: {
          ...state.createReviewRequestState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };

    case actionConstants.POST_CIN_NUMBER_VALIDATION_REQUEST:
      return {
        ...state,
        cinNumberValidationState: {
          ...state.cinNumberValidationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
    case actionConstants.POST_CIN_NUMBER_VALIDATION_SUCCESS:
      return {
        ...state,
        cinNumberValidationState: {
          ...state.cinNumberValidationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body,
          errorMessage: '',
        },
      };
    case actionConstants.POST_CIN_NUMBER_VALIDATION_FAILURE:
      return {
        ...state,
        cinNumberValidationState: {
          ...state.cinNumberValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.message || 'Failed to validate CIN number',
        },
      };
    case actionConstants.POST_CIN_NUMBER_VALIDATION_CLEAR:
      return {
        ...state,
        cinNumberValidationState: {
          ...state.cinNumberValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: '',
        },
      };
  case actionConstants.TOGGLE_ENVIRONMENT_REQUEST:
    return{
      ...state,
      toggleEnvState: {
        ...state.toggleEnvState,
        isLoading: true,
        isSuccess: false,
        isFailure: false,
        data: {},
        errorMessage: '',
      },
    };
  case actionConstants.TOGGLE_ENVIRONMENT_SUCCESS:
    return {
      ...state,
      toggleEnvState: {
        ...state.toggleEnvState,
        isLoading: false,
        isSuccess: true,
        isFailure: false,
        data: action?.payload?.body,
        errorMessage: '',
      },
    };
  case actionConstants.TOGGLE_ENVIRONMENT_FAILURE:
    return {
      ...state,
      toggleEnvState: {
        ...state.toggleEnvState,
        isLoading: false,
        isSuccess: false,
        isFailure: true,
        data: {},
        errorMessage: action?.payload?.body?.message || 'Failed to toggle environment',
      },
    };  

    case actionConstants.TOGGLE_ENVIRONMENT_CLEAR:
      return{
        ...state,
        toggleEnvState: {
          ...state.toggleEnvState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          errorMessage: '',
        }
      };

    case actionConstants.SHOW_OPPORTUNITY_STATUS_REQUEST:
  return {
    ...state,
    showOpportunityStatusState: {
      ...state.showOpportunityStatusState,
      isLoading: true,
      isSuccess: false,
      isFailure: false,
      errorMessage: ''
    },
  };

case actionConstants.SHOW_OPPORTUNITY_STATUS_SUCCESS:
  return {
    ...state,
    showOpportunityStatusState: {
      ...state.showOpportunityStatusState,
      isLoading: false,
      isSuccess: true,
      isFailure: false,
      data: action?.payload?.body,
      errorMessage: ''
    },
  };

case actionConstants.SHOW_OPPORTUNITY_STATUS_FAILURE:
  return {
    ...state,
    showOpportunityStatusState: {
      ...state.showOpportunityStatusState,
      isLoading: false,
      isSuccess: false,
      isFailure: true,
      data: {},
      errorMessage: action?.payload?.body?.message || 'Failed to load opportunity status'
    },
  };
    
    case actionConstants.SHOW_PDF_REQUEST:
      return {
        ...state,
        showPdfState: {
          ...state.showPdfState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          pdfUrl: null,
          errorMessage: '',
        },
      };
    case actionConstants.SHOW_PDF_SUCCESS:
      return {
        ...state,
        showPdfState: {
          ...state.showPdfState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          pdfUrl: action.payload.body,
          errorMessage: '',
        },
      };
    case actionConstants.SHOW_PDF_FAILURE:
      return {
        ...state,
        showPdfState: {
          ...state.showPdfState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          pdfUrl: null,
          errorMessage: action.payload?.body?.message || action.payload?.body?.error_message || 'Could not fetch merchant agreement. Please try again.',
        },
      };
    case actionConstants.SHOW_PDF_CLEAR:
      return {
        ...state,
        showPdfState: {
          ...state.showPdfState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          pdfUrl: null,
          errorMessage: '',
        },
      };

    case actionConstants.POST_VERIFY_OTP_PDF_REQUEST:
      return {
        ...state,
        validateOtpPdfState: {
          ...state.validateOtpPdfState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
          errorMessage: ''
        },
      };
    case actionConstants.POST_VERIFY_OTP_PDF_SUCCESS:
      return {
        ...state,
        validateOtpPdfState: {
          ...state.validateOtpPdfState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorMessage: ''
        },
      };
    case actionConstants.POST_VERIFY_OTP_PDF_FAILURE:
      return {
        ...state,
        validateOtpPdfState: {
          ...state.validateOtpPdfState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

      case actionConstants.POST_VERIFY_OTP_PDF_CLEAR:
        return {
          ...state,
          validateOtpPdfState: {
            ...state.validateOtpPdfState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
          },
        };

    case actionConstants.POST_SEND_OTP_PDF_REQUEST:
      return {
        ...state,
        sendOtpPdfState: {
          ...state.sendOtpPdfState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {},
        },
      };
    case actionConstants.POST_SEND_OTP_PDF_SUCCESS:
      return {
        ...state,
        sendOtpPdfState: {
          ...state.sendOtpPdfState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
        },
      };
    case actionConstants.POST_SEND_OTP_PDF_FAILURE:
      return {
        ...state,
        sendOtpPdfState: {
          ...state.sendOtpPdfState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

      case actionConstants.POST_SEND_OTP_PDF_CLEAR:
        return {
          ...state,
          sendOtpPdfState: {
            ...state.sendOtpPdfState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
          },
        };
   
  case actionConstants.GET_KYC_IMAGE_REQUEST:
  return {
    ...state,
    kycImageState: {
      isLoading: true,
      isSuccess: false,
      isFailure: false,
      imageUrl: null,
    },
  };

case actionConstants.GET_KYC_IMAGE_SUCCESS:{
  const blob = action.payload.body;
  const objectUrl = URL.createObjectURL(blob);
  return {
    ...state,
    kycImageState: {
      isLoading: false,
      isSuccess: true,
      isFailure: false,
      imageUrl: objectUrl,
    },
  };}

case actionConstants.GET_KYC_IMAGE_FAILURE:
  return {
    ...state,
    kycImageState: {
      isLoading: false,
      isSuccess: false,
      isFailure: true,
      imageUrl: null,
    },
  };

    case actionConstants.UPDATE_REVIEW_STEP_REQUEST:
      return {
        ...state,
        getReviewStepUpdateState:{
          ...state.getReviewStepUpdateState,
          isLoading: true,
          isSuccess: false,
          isFailure: false
        },
      };
    case actionConstants.UPDATE_REVIEW_STEP_SUCCESS:
      return {
        ...state,
        getReviewStepUpdateState:{
          ...state.getReviewStepUpdateState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body
        },
      };
    case actionConstants.UPDATE_REVIEW_STEP_FAILURE:
      return {
        ...state,
        getReviewStepUpdateState:{
          ...state.getReviewStepUpdateState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.COMPLETE_VIDEO_KYC_JOURNEY_REQUEST:
      return {
        ...state,
        getCompleteVKYCJourneyState:{
          ...state.getCompleteVKYCJourneyState,
          isLoading: true,
          isSuccess: false,
          isFailure: false
        },
      };
    case actionConstants.COMPLETE_VIDEO_KYC_JOURNEY_SUCCESS:
      return {
        ...state,
        getCompleteVKYCJourneyState:{
          ...state.getCompleteVKYCJourneyState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body
        },
      };
    case actionConstants.COMPLETE_VIDEO_KYC_JOURNEY_FAILURE:
      return {
        ...state,
        getCompleteVKYCJourneyState:{
          ...state.getCompleteVKYCJourneyState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.GET_STATES_DATA_REQUEST:
      return {
        ...state,
        getStateDataState:{
          ...state.getStateDataState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
        },
      };

    case actionConstants.GET_STATES_DATA_SUCCESS:
      return{
        ...state,
        getStateDataState:{
          ...state.getStateDataState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action?.payload?.body
        },
      };
     
    case actionConstants.GET_STATES_DATA_FAILURE:
      return{
        ...state,
        getStateDataState:{
          ...state.getStateDataState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

      case actionConstants.GET_CITY_DATA_REQUEST:
        return {
          ...state,
          getCitiesDataState:{
            ...state.getCitiesDataState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
          },
        };
  
      case actionConstants.GET_CITY_DATA_SUCCESS:
        return{
          ...state,
          getCitiesDataState:{
            ...state.getCitiesDataState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body
          },
        };
       
      case actionConstants.GET_CITY_DATA_FAILURE:
        return{
          ...state,
          getCitiesDataState:{
            ...state.getCitiesDataState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            errorMessage: action?.payload?.body?.error_details?.errorMessage,
          },
        };
        
    case actionConstants.GET_VIDEO_KYC_STATUS_REQUEST:
      return {
        ...state,
        getVideoKycStatusState:{
          ...state.getVideoKycStatusState,
          isLoading: true,
          isSuccess: false,
          isFailure: false
        },
      };
    case actionConstants.GET_VIDEO_KYC_STATUS_SUCCESS:
      return {
        ...state,
        getVideoKycStatusState:{
          ...state.getVideoKycStatusState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body
        },
      };
    case actionConstants.GET_VIDEO_KYC_STATUS_FAILURE:
      return {
        ...state,
        getVideoKycStatusState:{
          ...state.getVideoKycStatusState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

  case actionConstants.GET_VIDEO_KYC_URL_REQUEST:
    return {
      ...state,
      getVideoKycUrlState:{
        ...state.getVideoKycUrlState,
        isLoading: true,
        isSuccess: false,
        isFailure: false
      },
    };
    case actionConstants.GET_VIDEO_KYC_URL_SUCCESS:
      return {
        ...state,
        getVideoKycUrlState:{
          ...state.getVideoKycUrlState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorMessage:'',
        },
      };
    case actionConstants.GET_VIDEO_KYC_URL_FAILURE:
      return {
        ...state,
        getVideoKycUrlState:{
          ...state.getVideoKycUrlState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      }; 

      case actionConstants.GET_VIDEO_KYC_URL_CLEAR:
        return {
          ...state,
          getVideoKycUrlState:{
            ...state.getVideoKycUrlState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage:''
          },
        };


    case actionConstants.GET_MCC_DETAILS_REQUEST:
      return {
        ...state,
        getMccState:{
          ...state.getMccState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorTitle: '',
          errorMessage: ''
        },
      };

      case actionConstants.GET_MCC_DETAILS_SUCCESS:
        return {
          ...state,
          getMccState:{
            ...state.getMccState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body
          },
        };

      case actionConstants.GET_MCC_DETAILS_FAILURE:
        return {
          ...state,
          getMccState:{
            ...state.getMccState,
            isLoading:false,
            isSuccess: false,
            isFailure: true,
            errorTitle: action?.payload?.body?.error_details?.errorTitle,
            errorMessage: action?.payload?.body?.error_details?.errorMessage,
          },
        };

      case actionConstants.GET_MCC_DETAILS_CLEAR:
        return {
          ...state,
          getMccState: { ...getMccState },
        };
     
    case actionConstants.GET_PAN_AND_GST_DETAILS_REQUEST:
      return {
        ...state,
        panGstDetails:{
          ...state.panGstDetails,
          isLoading: true,
          isSuccess:false,
          isFailure: false,
          errorTitle: '',
          errorMessage: '',
        },
      };

      case actionConstants.GET_PAN_AND_GST_DETAILS_SUCCESS:
        return {
          ...state,
          panGstDetails:{
            ...state.panGstDetails,
            isLoading:false,
            isSuccess: true,
            isFailure:false,
            errorTitle: '',
            errorMessage: '',
            data: action.payload.body
          },
        };

        case actionConstants.GET_PAN_AND_GST_DETAILS_FAILURE:
          return{
            ...state,
            panGstDetails:{
              ...state.panGstDetails,
              isLoading:false,
              isSuccess: false,
              isFailure: true,
              errorTitle: "PAN verification failed!",
              errorMessage: action?.payload?.body?.error_details?.errorMessage,
            },
          };

          case actionConstants.GET_PAN_AND_GST_DETAILS_CLEAR:
            return{
              ...state,
              panGstDetails:{
                ...state.panGstDetails,
                isLoading:false,
                isSuccess: false,
                isFailure: false,
                errorTitle: '',
                errorMessage: '',
                data: []
              },
            };

    case actionConstants.GET_DIGI_VERIFY_REQUEST:
      return{
        ...state,
        digiVerificationState:{
          ...state.digiVerificationState,
          isLoading:true,
          isSuccess: false,
          isFailure: false,
          errorMessage: ''
        },
      };
      case actionConstants.GET_DIGI_VERIFY_SUCCESS:
        return{
          ...state,
          digiVerificationState:{
            ...state.digiVerificationState,
            isLoading:false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            errorMessage: ''
          },
        };

        case actionConstants.GET_DIGI_VERIFY_FAILURE:
          return{
            ...state,
            digiVerificationState:{
              ...state.digiVerificationState,
              isLoading:false,
              isSuccess: false,
              isFailure: true,
              errorMessage: action?.payload?.body?.error_details?.errorMessage,
            },
          };

          case actionConstants.GET_DIGI_VERIFY_CLEAR:
            return{
              ...state,
              digiVerificationState:{
                ...state.digiVerificationState,
                isLoading:false,
                isSuccess: false,
                isFailure: false,
                data: {}
              },
            };

          case actionConstants.GET_DIGI_DETAILS_REQUEST:
            return{
              ...state,
              digiDetailsState:{
                ...state.digiDetailsState,
                isLoading:true,
                isSuccess: false,
                isFailure: false,
                errorMessage: ''
              },
            };
            case actionConstants.GET_DIGI_DETAILS_SUCCESS:
              return{
                ...state,
                digiDetailsState:{
                  ...state.digiDetailsState,
                  isLoading:false,
                  isSuccess: true,
                  isFailure: false,
                  data: action.payload.body,
                  errorMessage: ''
                },
              };
      
              case actionConstants.GET_DIGI_DETAILS_FAILURE:
                return{
                  ...state,
                  digiDetailsState:{
                    ...state.digiDetailsState,
                    isLoading:false,
                    isSuccess: false,
                    isFailure: true,
                    errorMessage: action?.payload?.body?.error_details?.errorMessage,
                  },
                };

                case actionConstants.GET_DIGI_DETAILS_CLEAR:
                  return{
                    ...state,
                    digiDetailsState:{
                      ...state.digiDetailsState,
                      isLoading:false,
                      isSuccess: false,
                      isFailure: false,
                      data: {}
                    },
                  };
        

    case actionConstants.GET_STEP_DETAILS_REQUEST:
      return {
        ...state,
        stepperDetails:{
         ...state.stepperDetails,
         isLoading: true,
         isSuccess: false,
         isFailure: false,
        }
      };

    // case actionConstants.GET_STEP_DETAILS_SUCCESS:{
    //   const newData = action.payload.body; 
    //   return {
    //     ...state,
    //     stepperDetails:{
    //       ...state.stepperDetails,
    //       isLoading: false,
    //       isSuccess: true,
    //       isFailure: false,
    //       dataByStep: {
    //         ...state.stepperDetails.dataByStep,
    //         ...newData,
    //       },
    //      }
    //   };
    // }

    case actionConstants.GET_STEP_DETAILS_SUCCESS: {   
      const newData = action?.payload?.body; 
      return {
        ...state,
        stepperDetails: {
          ...state.stepperDetails,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: newData,
        },
      };  
    }

    case actionConstants.GET_STEP_DETAILS_FAILURE:
      return {
        ...state,
        stepperDetails:{
          ...state.stepperDetails,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        }
      };

    case actionConstants.POST_SAVE_BUSINESS_DETAILS_REQUEST:
      return {
        ...state,
        businessDetailsState: {
          ...state.businessDetailsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          businessWebsiteURL: '',
          privacyPolicyURL: '',
          annualTurnOver: '',
          businessCategory: '',
          businessSubCategory: '',
          merchantId: '',
        },
      };

    case actionConstants.POST_SAVE_BUSINESS_DETAILS_SUCCESS:
      return {
        ...state,
        businessDetailsState: {
          ...state.businessDetailsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          ...action?.payload?.body,
        },
      };

    case actionConstants.POST_SAVE_BUSINESS_DETAILS_FAILURE:
      return {
        ...state,
        businessDetailsState: {
          ...state.businessDetailsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          businessWebsiteURL: '',
          privacyPolicyURL: '',
          annualTurnOver: '',
          businessCategory: '',
          businessSubCategory: '',
          merchantId: '',
        },
      };

    case actionConstants.POST_SAVE_BUSINESS_DETAILS_CLEAR:
      return {
        ...state,
        businessDetailsState,
      };

      case actionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_REQUEST: 
        return {
          ...state,
          saveAndNext: {
            ...state.saveAndNext,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: ''
          },
        };
  
      case actionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_SUCCESS:
        return {
          ...state,
          saveAndNext: {
            ...state.saveAndNext,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            ...action?.payload?.body,
            errorMessage: ''
          },
        };
  
      case actionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_FAILURE:
        return {
          ...state,
          saveAndNext: {
            ...state.saveAndNext,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.error_details?.errorMessage,
          },
        };
  
      case actionConstants.POST_SELF_SERVE_SAVE_AND_NEXT_CLEAR:
        return {
          ...state,
          saveAndNext,
        };

      // Autosave draft
      case actionConstants.POST_AUTOSAVE_STEP_REQUEST:
        return {
          ...state,
          autosaveStep: {
            ...state.autosaveStep,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      case actionConstants.POST_AUTOSAVE_STEP_SUCCESS:
        return {
          ...state,
          autosaveStep: {
            ...state.autosaveStep,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            ...action?.payload?.body,
            errorMessage: '',
          },
        };

      case actionConstants.POST_AUTOSAVE_STEP_FAILURE:
        return {
          ...state,
          autosaveStep: {
            ...state.autosaveStep,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.error_details?.errorMessage || '',
          },
        };

      case actionConstants.POST_AUTOSAVE_STEP_CLEAR:
        return {
          ...state,
          autosaveStep: { ...autosaveStep },
        };
      
        case actionConstants.POST_BANK_ACCOUNT_VERIFICATION_REQUEST:
        return {
          ...state,
          bankAccountVerificationState: {
            ...state.bankAccountVerificationState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: null,
          },
        };

        case actionConstants.POST_BANK_ACCOUNT_VERIFICATION_SUCCESS:
          return {
            ...state,
            bankAccountVerificationState: {
              ...state.bankAccountVerificationState,
              isLoading: false,
              isSuccess: true,
              isFailure: false,
              data: action.payload.body,
              errorMessage: null,
            },
          };

        case actionConstants.POST_BANK_ACCOUNT_VERIFICATION_FAILURE:
          return {
            ...state,
            bankAccountVerificationState: {
              ...state.bankAccountVerificationState,
              isLoading: false,
              isSuccess: false,
              isFailure: true,
              errorMessage: action?.payload?.body?.error_details?.errorMessage,
            },
          };

        case actionConstants.POST_BANK_ACCOUNT_VERIFICATION_CLEAR:
          return {
            ...state,
            bankAccountVerificationState: { ...bankAccountVerificationState },
          };

    case actionConstants.POST_FETCH_KYC_DETAILS_REQUEST:
      return {
        ...state,
        fetchKycDetailsState: {
          ...state.fetchKycDetailsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          merchantId: '',
          merchantPAN: '',
          kycRefId: '',
          documentType: '',
          error: '',
          requestId: '',
          documentNumber: '',
          documentData: {
            completeAddress: '',
            dateOfBirth: '',
            email: '',
            gender: '',
            generatedAt: '',
            maskedNumber: '',
            name: '',
            phone: '',
            photoUrl: '',
            verified: {
              email: false,
              phone: false,
              signature: false,
            },
            address: null,
          },
        },
      };

    case actionConstants.POST_FETCH_KYC_DETAILS_SUCCESS:
      return {
        ...state,
        fetchKycDetailsState: {
          ...state.fetchKycDetailsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          ...action?.payload?.body,
        },
      };

    case actionConstants.POST_FETCH_KYC_DETAILS_FAILURE:
      return {
        ...state,
        fetchKycDetailsState: {
          ...state.fetchKycDetailsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          merchantId: '',
          merchantPAN: '',
          kycRefId: '',
          documentType: '',
          error: '',
          requestId: '',
          documentNumber: '',
          documentData: {
            completeAddress: '',
            dateOfBirth: '',
            email: '',
            gender: '',
            generatedAt: '',
            maskedNumber: '',
            name: '',
            phone: '',
            photoUrl: '',
            verified: {
              email: false,
              phone: false,
              signature: false,
            },
            address: null,
          },
        },
      };

    case actionConstants.POST_FETCH_KYC_DETAILS_CLEAR:
      return {
        ...state,
        fetchKycDetailsState,
      };

    case actionConstants.POST_KYC_VERIFICATION_REQUEST:
      return {
        ...state,
        kycVerificationState: {
          ...state.kycVerificationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          merchantId: '',
          merchantPAN: '',
          kycRefId: '',
          documentType: '',
          error: '',
          requestId: '',
          id: '',
          status: '',
          url: '',
          validUpto: '',
        },
      };

    case actionConstants.POST_KYC_VERIFICATION_SUCCESS:
      return {
        ...state,
        kycVerificationState: {
          ...state.kycVerificationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          ...action?.payload?.body,
        },
      };

    case actionConstants.POST_KYC_VERIFICATION_FAILURE:
      return {
        ...state,
        kycVerificationState: {
          ...state.kycVerificationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          merchantId: '',
          merchantPAN: '',
          kycRefId: '',
          documentType: '',
          error: '',
          requestId: '',
          id: '',
          status: '',
          url: '',
          validUpto: '',
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.POST_KYC_VERIFICATION_CLEAR:
      return {
        ...state,
        kycVerificationState,
      };

    case actionConstants.GET_PRODUCT_LISTING_REQUEST:
      return {
        ...state,
        productListState: {
          ...state.productListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          products: null,
        },
      };

    case actionConstants.GET_PRODUCT_LISTING_SUCCESS:
      return {
        ...state,
        productListState: {
          ...state.productListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          products: action.payload.body,
        },
      };

    case actionConstants.GET_PRODUCT_LISTING_FAILURE:
      return {
        ...state,
        productListState: {
          ...state.productListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          products: null,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.GET_PRODUCT_LISTING_CLEAR:
      return {
        ...state,
        productListState,
      };

    case actionConstants.POST_SELECTED_PRODUCT_LISTING_REQUEST:
      return {
        ...state,
        selectedProductListState: {
          ...state.selectedProductListState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          responseCode: '',
          responseMessage: '',
          href: '' 
        },
      };

    case actionConstants.POST_SELECTED_PRODUCT_LISTING_SUCCESS:
      return {
        ...state,
        selectedProductListState: {
          ...state.selectedProductListState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          ...action?.payload?.body,
        },
      };

    case actionConstants.POST_SELECTED_PRODUCT_LISTING_FAILURE:
      return {
        ...state,
        selectedProductListState: {
          ...state.selectedProductListState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          ...action?.payload?.body,
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.POST_SELECTED_PRODUCT_LISTING_CLEAR:
      return {
        ...state,
        selectedProductListState,
      };

    case actionConstants.POST_PAN_VALIDATION_REQUEST:
      return {
        ...state,
        panValidationState: {
          ...state.panValidationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          data: {}
        },
      };

    case actionConstants.POST_PAN_VALIDATION_SUCCESS:
      return {
        ...state,
        panValidationState: {
          ...state.panValidationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: {...action?.payload?.body},
        },
      };

    case actionConstants.POST_PAN_VALIDATION_FAILURE:
      return {
        ...state,
        panValidationState: {
          ...state.panValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          data: {},
          errorTitle: "PAN VERIFICATION FAILED",
          errorMessage:action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.POST_PAN_VALIDATION_CLEAR:
      return {
        ...state,
        panValidationState,
      };

    case actionConstants.POST_FETCH_GST_DETAILS_REQUEST:
      return {
        ...state,
        fetchGstDetailsState: {
          ...state.fetchGstDetailsState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          merchantPAN: '',
          kycRefId: '',
          documentType: '',
          requestId: '',
          documentNumber: '',
          gst: [],
        },
      };

    case actionConstants.POST_FETCH_GST_DETAILS_SUCCESS:
      return {
        ...state,
        fetchGstDetailsState: {
          ...state.fetchGstDetailsState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          ...action?.payload?.body,
        },
      };

    case actionConstants.POST_FETCH_GST_DETAILS_FAILURE:
      return {
        ...state,
        fetchGstDetailsState: {
          ...state.fetchGstDetailsState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          merchantPAN: '',
          kycRefId: '',
          documentType: '',
          requestId: '',
          documentNumber: '',
          gst: [],
        },
      };

    case actionConstants.POST_FETCH_GST_DETAILS_CLEAR:
      return {
        ...state,
        fetchGstDetailsState,
      };

    case actionConstants.POST_GST_VALIDATION_REQUEST:
      return {
        ...state,
        gstValidationState: {
          ...state.gstValidationState,
          isLoading: true,
          isSuccess: false,
          isFailure: false,
          errorTitle: '',
          errorMessage: '',
        },
      };

    case actionConstants.POST_GST_VALIDATION_SUCCESS:
      return {
        ...state,
        gstValidationState: {
          ...state.gstValidationState,
          isLoading: false,
          isSuccess: true,
          isFailure: false,
          data: action.payload.body,
          errorTitle: '',
          errorMessage: '',
        },
      };

    case actionConstants.POST_GST_VALIDATION_FAILURE:
      return {
        ...state,
        gstValidationState: {
          ...state.gstValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: true,
          errorTitle: action?.payload?.body?.error_details?.errorTitle || '',
          errorMessage: action?.payload?.body?.error_details?.errorMessage,
        },
      };

    case actionConstants.POST_GST_VALIDATION_CLEAR:
      return {
        ...state,
        gstValidationState:{
          ...state.gstValidationState,
          isLoading: false,
          isSuccess: false,
          isFailure: false,
          data:[],
          errorTitle: '',
          errorMessage: '',
        },
      };

      case actionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_REQUEST:
        return {
          ...state,
          publicTokenValidationState: {
            ...state.publicTokenValidationState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            errorTitle: '',
            errorMessage: '',
          },
        };
  
      case actionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_SUCCESS:
        return {
          ...state,
          publicTokenValidationState: {
            ...state.publicTokenValidationState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action.payload.body,
            errorTitle: '',
            errorMessage: '',
          },
        };
  
      case actionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_FAILURE:
        return {
          ...state,
          publicTokenValidationState: {
            ...state.publicTokenValidationState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            errorTitle: action?.payload?.body?.error_details?.errorTitle || '',
            errorMessage: action?.payload?.body?.error_details?.errorMessage,
          },
        };
  
      case actionConstants.POST_PUBLIC_TOKEN_SELF_SERVE_VERIFICATION_CLEAR:
        return {
          ...state,
          publicTokenValidationState,
        };

      case actionConstants.ADD_AND_UPDATE_BENEFICIARY_REQUEST:
        return {
          ...state,
          addAndUpdateBeneficiaryState: {
            ...state.addAndUpdateBeneficiaryState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      case actionConstants.ADD_AND_UPDATE_BENEFICIARY_SUCCESS:
        return {
          ...state,
          addAndUpdateBeneficiaryState: {
            ...state.addAndUpdateBeneficiaryState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body,
            errorMessage: '',
          },
        };

      case actionConstants.ADD_AND_UPDATE_BENEFICIARY_FAILURE:
        return {
          ...state,
          addAndUpdateBeneficiaryState: {
            ...state.addAndUpdateBeneficiaryState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.message || 'Failed to add/update beneficiary',
          },
        };

      case actionConstants.ADD_AND_UPDATE_BENEFICIARY_CLEAR:
        return {
          ...state,
          addAndUpdateBeneficiaryState: {
            ...state.addAndUpdateBeneficiaryState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      case actionConstants.RESEND_EMAIL_BENEFICIARY_REQUEST:
        return {
          ...state,
          resendEmailBeneficiaryState: {
            ...state.resendEmailBeneficiaryState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      case actionConstants.RESEND_EMAIL_BENEFICIARY_SUCCESS:
        return {
          ...state,
          resendEmailBeneficiaryState: {
            ...state.resendEmailBeneficiaryState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body,
            errorMessage: '',
          },
        };

      case actionConstants.RESEND_EMAIL_BENEFICIARY_FAILURE:
        return {
          ...state,
          resendEmailBeneficiaryState: {
            ...state.resendEmailBeneficiaryState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.message || 'Failed to resend email',
          },
        };

      case actionConstants.RESEND_EMAIL_BENEFICIARY_CLEAR:
        return {
          ...state,
          resendEmailBeneficiaryState: {
            ...state.resendEmailBeneficiaryState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      case actionConstants.GET_BENEFICIARY_OWNERS_REQUEST:
        return {
          ...state,
          getBeneficiaryOwnersState: {
            ...state.getBeneficiaryOwnersState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      case actionConstants.GET_BENEFICIARY_OWNERS_SUCCESS:
        return {
          ...state,
          getBeneficiaryOwnersState: {
            ...state.getBeneficiaryOwnersState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body,
            errorMessage: '',
          },
        };

      case actionConstants.GET_BENEFICIARY_OWNERS_FAILURE:
        return {
          ...state,
          getBeneficiaryOwnersState: {
            ...state.getBeneficiaryOwnersState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.message || 'Failed to get beneficiary owners',
          },
        };

      case actionConstants.GET_BENEFICIARY_OWNERS_CLEAR:
        return {
          ...state,
          getBeneficiaryOwnersState: {
            ...state.getBeneficiaryOwnersState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      // Sidebar step click
      case actionConstants.SIDEBAR_STEP_CLICK_REQUEST:
        return {
          ...state,
          sidebarStepClick: {
            ...state.sidebarStepClick,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };
      case actionConstants.SIDEBAR_STEP_CLICK_SUCCESS:
        return {
          ...state,
          sidebarStepClick: {
            ...state.sidebarStepClick,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            ...action?.payload?.body,
            errorMessage: '',
          },
        };
      case actionConstants.SIDEBAR_STEP_CLICK_FAILURE:
        return {
          ...state,
          sidebarStepClick: {
            ...state.sidebarStepClick,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.message || '',
          },
        };
      case actionConstants.SIDEBAR_STEP_CLICK_CLEAR:
        return {
          ...state,
          sidebarStepClick: {
            ...state.sidebarStepClick,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

      // Update PCI DSS Consent
      case actionConstants.UPDATE_PCI_DSS_CONSENT_REQUEST:
        return {
          ...state,
          updatePciDssConsentState: {
            ...state.updatePciDssConsentState,
            isLoading: true,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };
      case actionConstants.UPDATE_PCI_DSS_CONSENT_SUCCESS:
        return {
          ...state,
          updatePciDssConsentState: {
            ...state.updatePciDssConsentState,
            isLoading: false,
            isSuccess: true,
            isFailure: false,
            data: action?.payload?.body,
            errorMessage: '',
          },
        };
      case actionConstants.UPDATE_PCI_DSS_CONSENT_FAILURE:
        return {
          ...state,
          updatePciDssConsentState: {
            ...state.updatePciDssConsentState,
            isLoading: false,
            isSuccess: false,
            isFailure: true,
            data: {},
            errorMessage: action?.payload?.body?.message || 'Failed to update PCI DSS consent',
          },
        };
      case actionConstants.UPDATE_PCI_DSS_CONSENT_CLEAR:
        return {
          ...state,
          updatePciDssConsentState: {
            ...state.updatePciDssConsentState,
            isLoading: false,
            isSuccess: false,
            isFailure: false,
            data: {},
            errorMessage: '',
          },
        };

    default:
      return state;
  }
}
